import React from "react";
import AppSwitch from "@toothfairy/shared-ui/AppSwitch";
import AppTrackSlider from "@toothfairy/shared-ui/AppTrackSlider";
import useWorkspaces from "../../../Hooks/useWorkspaces";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppToast from "@toothfairy/shared-ui/AppToast";
import useSections from "../../../Hooks/useSections";
import workspacesHelper from "../../../API/Workspaces/workspacesHelper";
import { useTranslation } from "react-i18next";
import Constants from "../../../Constants";
import { Platform, View } from "react-native";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppExpander from "@toothfairy/shared-ui/AppExpander";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import { isLargeScreen } from "../../MainViewContainer";

const NotificationsContainer = () => {
  const {
    getActiveWorkspace,
    updateWorkspaceInContext,
    isBatchEnabled,
    isWorkspaceOnDemand,
    getPlanConfig,
  } = useWorkspaces();
  const { currentTheme } = AppTheme.useTheme();
  const { marginLeftUnderAppExpander } = useSections();
  const AppToasty = AppToast.useToast();
  const { t } = useTranslation();
  const { NOTIFICATION_OPTIONS } = Constants;

  // Helper function to translate notification labels
  const getNotificationLabel = (option) => {
    switch (option.id) {
      case "NOTIFICATION_ON_TR_COMPLETED":
        return t("admin.notifications.emailOnCompleted");
      case "NOTIFICATION_ON_TR_FAILED":
        return t("admin.notifications.emailOnFailed");
      case "NOTIFICATION_ON_TR_START":
        return t("admin.notifications.emailOnStart");
      case "NOTIFICATION_ON_BT_COMPLETED":
        return t("admin.notifications.emailOnCompleted");
      case "NOTIFICATION_ON_BT_FAILED":
        return t("admin.notifications.emailOnFailed");
      case "NOTIFICATION_ON_BT_START":
        return t("admin.notifications.emailOnStart");
      case "NOTIFICATION_TO_ALL_USERS":
        return t("admin.notifications.notifyAllUsers");
      case "NOTIFICATION_ON_API_CONSUMPTION":
        return t("admin.notifications.notifyConsumption");
      default:
        return option.label;
    }
  };
  const { state } = AppStateManager.useAppStateManager();

  const handleWorkspaceUpdate = async (property, value) => {
    try {
      const result = await workspacesHelper.updateWorkspace(
        getActiveWorkspace()?.id,
        [{ property, value }],
      );
      updateWorkspaceInContext(result);
      AppToasty.show(t("WorkspaceUpdateCaption"), {
        type: "success",
      });
    } catch (error) {
      AppToasty.show(t("WorkspaceUpdateFailedCaption"), {
        type: "danger",
      });
      console.error("An error occured while updating the workspace", error);
    }
  };
  return (
    <View
      style={{
        width: Platform.OS === "web" && isLargeScreen() ? 450 : 350,
        marginTop: 20,
        marginLeft: marginLeftUnderAppExpander,
        alignSelf: "center",
      }}
    >
      <AppExpander
        title={t("admin.notifications.consumptionTitle")}
        icon={AppAssets.icons.parser}
        style={{ minWidth: isLargeScreen() ? 530 : 250 }}
        isExpandedOnLoad={true}
      >
        {NOTIFICATION_OPTIONS.filter((u) => u.type === "PR").map((u) => (
          <View
            style={{
              flexDirection: "column",
              flex: 1,
              justifyContent: "space-between",
              marginBottom: 0,
              paddingLeft: !isLargeScreen() && 0,
            }}
          >
            <AppSwitch
              disabled={isWorkspaceOnDemand() && u.disabledIfBase === true}
              wrapperStyle={{
                flex: 1,
                marginRight: 20,
                marginBottom: 10,
              }}
              showTextInputLabel={true}
              label={getNotificationLabel(u)}
              description={u?.description ? t(u?.description) : undefined}
              descriptionIcon={true}
              onChange={(v) => {
                handleWorkspaceUpdate("notificationConfig", {
                  ...getActiveWorkspace().notificationConfig,
                  [u?.logicalPropertyName]: v,
                });
              }}
              isTicked={
                getActiveWorkspace()?.notificationConfig &&
                getActiveWorkspace()?.notificationConfig[u?.logicalPropertyName]
              }
            />
            {getActiveWorkspace()?.notificationConfig &&
              getActiveWorkspace()?.notificationConfig[
                u?.logicalPropertyName
              ] &&
              u?.showSlider && (
                <AppTrackSlider
                  maximumValue={100}
                  minimumValue={0}
                  step={1}
                  unitLabel={" %"}
                  valueLabel={t("admin.notifications.thresholdLabel")}
                  value={
                    getActiveWorkspace()?.notificationConfig[
                      u?.sliderPropertyName
                    ] || Constants.baseThreasholdConsumption
                  }
                  onValueChange={(v) =>
                    handleWorkspaceUpdate("notificationConfig", {
                      ...getActiveWorkspace().notificationConfig,
                      [u?.sliderPropertyName]: v,
                    })
                  }
                  wrapperStyle={{
                    marginLeft: 0,
                    marginBottom: 20,
                  }}
                />
              )}
          </View>
        ))}
      </AppExpander>

      <AppExpander
        title={t("admin.notifications.fineTuneTitle")}
        icon={AppAssets.icons.slidersH}
        style={{ minWidth: isLargeScreen() ? 530 : 250 }}
        isExpandedOnLoad={true}
      >
        {NOTIFICATION_OPTIONS.filter((u) => u.type === "TR").map((u) => (
          <View
            style={{
              flexDirection: "row",
              flex: 1,
              justifyContent: "space-between",
              marginBottom: 10,
              paddingLeft: !isLargeScreen() && 0,
            }}
          >
            <AppSwitch
              wrapperStyle={{
                flex: 1,
                marginRight: 20,
                marginBottom: 0,
              }}
              showTextInputLabel={true}
              label={getNotificationLabel(u)}
              description={u?.description ? t(u?.description) : undefined}
              descriptionIcon={true}
              onChange={(v) => {
                handleWorkspaceUpdate("notificationConfig", {
                  ...getActiveWorkspace().notificationConfig,
                  [u?.logicalPropertyName]: v,
                });
              }}
              isTicked={
                getActiveWorkspace()?.notificationConfig &&
                getActiveWorkspace()?.notificationConfig[u?.logicalPropertyName]
              }
            />
          </View>
        ))}
      </AppExpander>

      {isBatchEnabled() && (
        <AppExpander
          title={t("admin.notifications.benchmarksTitle")}
          icon={AppAssets.icons.benchmark}
          style={{ minWidth: isLargeScreen() ? 530 : 250 }}
          isExpandedOnLoad={false}
        >
          {NOTIFICATION_OPTIONS.filter((u) => u.type === "BT").map((u) => (
            <View
              style={{
                flexDirection: "row",
                flex: 1,
                justifyContent: "space-between",
                marginBottom: 10,
                paddingLeft: !isLargeScreen() && 0,
              }}
            >
              <AppSwitch
                wrapperStyle={{
                  flex: 1,
                  marginRight: 20,
                  marginBottom: 0,
                }}
                showTextInputLabel={true}
                label={getNotificationLabel(u)}
                description={u?.description ? t(u?.description) : undefined}
                descriptionIcon={true}
                onChange={(v) => {
                  handleWorkspaceUpdate("notificationConfig", {
                    ...getActiveWorkspace().notificationConfig,
                    [u?.logicalPropertyName]: v,
                  });
                }}
                isTicked={
                  getActiveWorkspace()?.notificationConfig &&
                  getActiveWorkspace()?.notificationConfig[
                    u?.logicalPropertyName
                  ]
                }
              />
            </View>
          ))}
        </AppExpander>
      )}
    </View>
  );
};

export default NotificationsContainer;
